<template>
  <a
    class="leonardo-anchor btn text-decoration-none btn-primary"
    :class="variant === 'dark' ? 'leonardo-button-dark' : 'leonardo-button'"
    :href="url"
    :target="open_in_new_window ? '_blank' : '_self'"
    @click.prevent="onClick"
  >
    <span>{{ label }}</span>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      :fill="variant === 'dark' ? 'grey' : '#00000066'"
      viewBox="0 0 16 16"
      style="align-self: center"
    >
      <path
        fill-rule="evenodd"
        d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5"
      />
      <path
        fill-rule="evenodd"
        d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z"
      />
    </svg>
  </a>
</template>
<script lang="ts" setup>
import { rbgContentPageLinkClickedV100 } from "kaleido-event-tracker";

export interface LeonardoCtaButtonProps {
  url: string;
  label: string;
  variant?: "primary" | "dark";
  open_in_new_window?: boolean;
  link_tracking_identifier?: string;
}

const props = defineProps<LeonardoCtaButtonProps>();

const onClick = () => {
  if (props.link_tracking_identifier) {
    rbgContentPageLinkClickedV100({ identifier: props.link_tracking_identifier });
  }
  if (props.open_in_new_window) {
    window.open(props.url, "_blank");
  } else {
    window.location.href = props.url;
  }
};
</script>
